import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import SpinnerComponent from '../layout/spinner';
import { post, get, construirMensaje, parseBackendError } from "../../helpers/apiHttp";


const RegistrarUbicacionColombia = ({ show, handleClose, order, tienda, busqueda }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formulario, setFormulario] = useState({
    departamento: "",
    ciudad: "",
    tienda: "",
    idorden: ""
  });

  const resetFormulario = () => {
    setFormulario({
      departamento: "",
      ciudad: "",
      tienda: tienda,
      idorden: order?.data.order_id || "",
    });
    setCiudades([]);
  };

  useEffect(() => {
    if (show) {
      resetFormulario();
      fetchDepartamentos(tienda);
    }
  }, [show]);

  const fetchDepartamentos = async (tienda_id) => {
    try {
      let $url = `backend/zones/provinces?tienda=${tienda_id}&idorden=${order.data.order_id}`;
      setIsLoading(true);
      const data = await get($url);
      setIsLoading(false);

      if (data.statusCode === 200) {
        setDepartamentos(data.result || []);
      } else {
        Swal.fire('Error', 'No se pudieron cargar los departamentos', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar los departamentos', 'error');
    }
  };

  const fetchCiudades = async (tienda_id, departamento) => {
    const formData = new FormData();
    formData.append('tienda', tienda_id);
    //formData.append('id_provincia', "hola");
    formData.append('id_provincia', departamento);
    formData.append('idorden', order.data.order_id);

    try {
      let $url = 'backend/zones/cities';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);
      if (data.statusCode === 200) {
        setCiudades(data.result || []);
      } else if(data.statusCode === 422){
        Swal.fire('Error', parseBackendError(data.errorMessage), 'error');
      }else{
        Swal.fire('Error', 'No se pudieron cargar las ciudades', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar las ciudades', 'error');
    }
  };

  const handleDepartamentoChange = async (event) => {
    const value = event.target.value;
    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      departamento: value,
      ciudad: "",
    }));

    setCiudades([]);

    if (value) {
      await fetchCiudades(tienda, value);
    }
  };

  const handleCiudadChange = (event) => {
    const value = event.target.value;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      ciudad: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    if (!formulario.departamento) {
      construirMensaje('', 'Debe seleccionar un departamento', 'warning');
      return;
    }

    if (!formulario.ciudad) {
      construirMensaje('', 'Debe seleccionar una ciudad', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('id_provincia', formulario.departamento);
    formData.append('id_city', formulario.ciudad);
    formData.append('tienda', formulario.tienda);
    formData.append('idorden', formulario.idorden);

    try {
      setIsSubmitting(true);
      let $url = 'backend/order/zone';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);

      if (data.isSuccessful === true && data.statusCode === 200) {
        construirMensaje(data.errorMessage, 'La ciudad de destino fue actualizada con éxito', 'success');
        busqueda();
        handleClose();
      } else {
        construirMensaje(data.errorMessage, 'Error durante el proceso', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error de formulario',
        text: 'Error al enviar el formulario',
        footer: ''
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <SpinnerComponent />
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Actualizar ciudad destino - Colombia</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit} encType="multipart/form-data">
              <Form.Group className="mb-3">
                <Form.Label>Departamento</Form.Label>
                <Form.Select
                  aria-label="Seleccione un departamento"
                  name="departamento"
                  value={formulario.departamento}
                  onChange={handleDepartamentoChange}
                >
                  <option value="">Seleccione una opción</option>
                  {departamentos.map((opcion) => (
                    <option key={opcion.id} value={opcion.id}>
                      {opcion.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Ciudad</Form.Label>
                <Form.Select
                  aria-label="Seleccione una ciudad"
                  name="ciudad"
                  value={formulario.ciudad}
                  onChange={handleCiudadChange}
                  disabled={!formulario.departamento}
                >
                  <option value="">Seleccione una opción</option>
                  {ciudades.map((opcion) => (
                    <option key={opcion.id} value={opcion.id}>
                      {opcion.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
            <Button variant="primary" type="submit" disabled={isSubmitting} onClick={handleSubmit}>
              Actualizar ciudad destino
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default RegistrarUbicacionColombia;